// extracted by mini-css-extract-plugin
export var select = "_qv-0";